
export enum AttributeType {
  NONE = '',
  BUSES = 'BUSES',
  TRUCKS = 'TRUCKS',
  TRACTS = 'TRACTS',
  TRAILERS = 'TRAILERS',
  ACCESSORIES = 'ACCESSORIES',
  VANS = 'VANES',
  NON_DAIMLER = 'NON_DAIMLER',
  LOAD = 'LOAD',
  VANES = 'VANES',
  NATURAL_PERSON = 'NATURAL_PERSON',
  LEGAL_PERSON = 'LEGAL_PERSON',
  WEB = 'WEB',
  DEALERS = 'DEALERS',
  COMMERCIAL_MANAGEMENT = 'COMMERCIAL_MANAGEMENT',
  DEALER_PARTIAL = 'DEALER_PARTIAL',
  DEALER_FULL = 'DEALER_FULL',
}

export enum DealerType {
  DEALER_PARTIAL = 'DEALER_PARTIAL',
  DEALER_FULL = 'DEALER_FULL',
}

export type FilterType = {
  formControlName: any;
  value: any;
  description: string;
  edit: boolean;
  isChecked: boolean;
  partial: boolean;
}

export type PartialFilterType = Partial<FilterType>;

export const filtersProductType : PartialFilterType[] = [
  { formControlName: 'buses', value: AttributeType.BUSES, description: 'Autobuses', edit: true, isChecked: false },
  { formControlName: 'trucks', value: AttributeType.TRUCKS, description: 'Camiones', edit: true, isChecked: false },
  { formControlName: 'tracts', value: AttributeType.TRACTS, description: 'Tractos', edit: true, isChecked: false },
  { formControlName: 'accessories', value: AttributeType.ACCESSORIES, description: 'Accesorios', edit: true, isChecked: false },
  //{ formControlName: 'vans', value: AttributeType.VANS, description: 'Vans', edit: true, isChecked: false },
  { formControlName: 'nonDaimler', value: AttributeType.NON_DAIMLER, description: 'No Daimler', edit: true, isChecked: false },
]

//filter dealers

export const filterDealers: PartialFilterType[] = [
  { formControlName: 'dealersFull', value: DealerType.DEALER_FULL, description: 'Lista completa', edit: false, isChecked: false },
  { formControlName: 'dealersPartial', value: DealerType.DEALER_PARTIAL, description: 'Lista parcial', edit: true, isChecked: false },

]
export const filterPersonType: PartialFilterType[] = [
  { formControlName: 'legalPerson', value: AttributeType.LEGAL_PERSON, description: 'Persona moral', edit: false, isChecked: false },
  { formControlName: 'naturalPerson', value: AttributeType.NATURAL_PERSON, description: 'Persona física', edit: false, isChecked: false },
]

export const filterQuoteType: PartialFilterType[] = [
  { formControlName: 'dealers', value: AttributeType.DEALERS, description: 'Distribuidores', edit: false, isChecked: false },
  { formControlName: 'web', value: AttributeType.WEB, description: 'Web', edit: false, isChecked: false },
  { formControlName: 'commercialManagement', value: AttributeType.COMMERCIAL_MANAGEMENT, description: 'Gerencia comercial', edit: false, isChecked: false },

]

export const filterTypes = {
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  PERSON_TYPE: 'PERSON_TYPE',
  QUOTE_TYPE: 'QUOTE_TYPE',
  DEALER_TYPE: 'DEALER_TYPE'

}
export const optionsProductTypes = [
  {
    filterType: {
      name: 'Tipo de unidad',
      type: filterTypes.PRODUCT_TYPE,
      filter: filtersProductType
    }
  },
  {
    filterType: {
      name: 'Tipo de persona',
      type: filterTypes.PERSON_TYPE,
      filter: filterPersonType
    }
  },

  {
    filterType: {
      name: 'Tipo de cotizador',
      type: filterTypes.QUOTE_TYPE,
      filter: filterQuoteType
    }
  },

  {
    filterType: {
      name: 'Distribuidores',
      type: filterTypes.DEALER_TYPE,
      filter: filterDealers
    }
  }
];
